import { render, staticRenderFns } from "./JourneyManagement.vue?vue&type=template&id=558ec960&lang=pug&"
import script from "./JourneyManagement.vue?vue&type=script&lang=js&"
export * from "./JourneyManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports